import React from 'react';
import { Form } from 'react-bootstrap';
import { FormNumber, Selectize } from '~/components/FormControl';
import { REVEALED_PHASE_OPTIONS } from '~/config/constants';

function RestrictionDetail() {
    return (
        <Form.Row className="justify-content-between">
            <Selectize
                sm="3"
                name="restrictionDetail.phaseRestrictionOptions"
                options={[...REVEALED_PHASE_OPTIONS] || []}
            />
            <FormNumber
                name="restrictionDetail.minimumHpValue"
                className={'offset-sm-1'}
                sm="3"
            />
            <FormNumber
                name="restrictionDetail.minimumPointValue"
                className={'offset-sm-1'}
                sm="3"
            />
        </Form.Row>
    );
}

export default RestrictionDetail;
